<template>
  <div class="translator dropdown">
    <div
      class="tooltip bs-tooltip-top show"
      role="tooltip"
      v-if="showing"
      style="margin-top: -35px"
      @click="hide"
    >
      <div class="arrow" style="left: 10px"></div>
      <div class="tooltip-inner">
        <span class="closer">&times;</span>
        <div>{{ text }}</div>
      </div>
    </div>
    <slot></slot>
    <button class="btn btn-sm p-1 btn-translate" @click="dropdown = !dropdown">
      <!-- <svg v-if="!loading" style="width: 40px; height: 20px;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="language" class="svg-inline--fa fa-language fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"></path></svg> -->
      <svg
        v-if="!loading"
        style="width: 30px; height: 33px"
        version="1.1"
        viewBox="100 100 500 500"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g>
          <path
            d="m301.78 255.55c11.836 8.8516 26.523 16.105 42.855 16.105v12.602c-17.691 0-35.66-6.9922-52.723-20.387-3.4922 2.6445-7.0781 5.0586-10.75 7.2344-14.734 8.7266-30.125 13.152-45.742 13.152v-12.602c16.121 0 32.086-5.6172 46.773-16.203-1.5547-1.4766-3.1016-3.0078-4.6406-4.5938-16.949-17.516-31.816-40.965-40.793-64.34l11.762-4.5156c8.3867 21.848 22.27 43.754 38.082 60.094 1.6875 1.7461 3.5078 3.5352 5.4414 5.3242 5.4609-4.9883 10.688-10.699 15.621-17.109 17.793-23.121 28.938-52.18 30.477-78.934h-132.21v-12.602h77.797v-30.832h12.602v30.832h77.797v12.602h-23.355c-1.5391 29.43-13.668 61.359-33.109 86.621-4.9883 6.4727-10.293 12.332-15.883 17.551zm187.14 139.89h-15.918l-18.387-49.328h-70.965l-17.938 49.328h-15.918l62.555-164.91h14.352zm-39.125-62.441-27.129-74.102c-1.4961-4.0352-2.6172-7.9961-3.3633-11.883h-0.44922c-0.44922 2.4648-1.0664 4.9141-1.8516 7.3438s-10.258 28.645-28.418 78.641z"
            stroke-width="13"
            fill="#007bff"
            stroke="#007bff"
          />
        </g>
      </svg>

      <svg
        v-else
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="spinner"
        class="svg-inline--fa fa-spinner fa-w-16"
        style="
          width: 20px;
          height: 20px;
          animation: loader-rotate 1s linear infinite;
        "
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          fill="currentColor"
          d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
        ></path>
      </svg>
    </button>
    <div
      class="dropdown-menu show"
      aria-labelledby="dropdownMenuButton"
      v-if="dropdown"
      style="left: unset; right: 0"
    >
      <a class="dropdown-item" @click="translate('ru')">ru</a>
      <a class="dropdown-item" @click="translate('en')">en</a>
      <a class="dropdown-item" @click="translate('zh')">cn</a>
    </div>
  </div>
</template>
<style scoped>
.tooltip {
  cursor: pointer;
}
.tooltip .closer {
  position: absolute;
  color: red;
  right: 5px;
  top: 5px;
}
.tooltip .tooltip-inner div {
  font-size: 16px;
  font-weight: 400;
}
.translator {
  position: relative;
}
.btn-translate {
  background: transparent;
  color: #3a2a9a;
  box-shadow: none;
  position: absolute;
  top: 13px;
  right: 0;
}
.btn-translate:hover,
.btn-translate:active,
.btn-translate:focus {
  background: transparent !important;
  opacity: 0.7;
  color: #3a2a9a !important;
}
</style>
<script>
export default {
  name: "translatable-field",
  data() {
    return {
      showing: false,
      text: "",
      loading: false,
      dropdown: false,
    };
  },
  methods: {
    hide() {
      this.showing = false;
    },
    show(text) {
      this.showing = true;
      this.text = text;
    },
    translate(lang) {
      // if(this.text!==''){
      //     this.show(this.text)
      //     return true;
      // }
      if (lang == "") lang = this.$i18n.locale;
      if (lang == "cn") lang = "zh";

      this.$slots.default.forEach((slot) => {
        let input = slot.elm;

        let text = "";
        if (input) text = input.value;

        this.loading = true;
        axios
          .get(
            window.base +
              "/library/translate?text=" +
              text +
              "&source=ru&target=" +
              lang,
          )
          .then((response) => {
            this.loading = false;
            this.dropdown = false;
            this.$emit("updateTranslation", response.data.translations[0].text);
          });
      });
    },
  },
};
</script>
